import { OrderDetails, OrderItem } from '@/types/orders';

export interface OrderNote {
  label?: string;
  text: string;
}

const stripQuotes = (text: string | null | undefined): string =>
  text ? text.replace(/^"(.*)"$/, '$1').trim() : '';

const collectItemNotes = (items: OrderItem[] | undefined): OrderNote[] =>
  (items ?? []).flatMap((item) => {
    const text = stripQuotes(item.notes);
    return [
      ...(text ? [{ label: stripQuotes(item.name), text }] : []),
      ...collectItemNotes(item.modifiers),
      ...collectItemNotes(item.mains),
      ...collectItemNotes(item.sides),
    ];
  });

export const collectNotes = (orderDetails: OrderDetails | undefined): OrderNote[] => {
  if (!orderDetails) {
    return [];
  }

  const orderNote = stripQuotes(orderDetails.orderNotes);

  return [
    ...(orderNote ? [{ text: orderNote }] : []),
    ...collectItemNotes(orderDetails.items),
  ];
};

export const truncateNotes = (notes: OrderNote[], maxLength: number): OrderNote[] => {
  const truncated: OrderNote[] = [];
  let remaining = maxLength;

  for (const note of notes) {
    if (remaining <= 0) {
      break;
    }

    const labelLength = note.label ? note.label.length + 2 : 0;
    const availableForText = remaining - labelLength;

    if (availableForText <= 0) {
      break;
    }

    if (note.text.length > availableForText) {
      truncated.push({ ...note, text: `${note.text.slice(0, availableForText)}…` });
      break;
    }

    truncated.push(note);
    remaining -= labelLength + note.text.length;
  }

  return truncated;
};